<template>
  <div id="app"><router-view /></div>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {},
  mounted() {},
  created() {
    
  },
};
</script>

<style lang="scss" scoped>
</style>